import Box from '@mui/material/Box';
import { lighten } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import iconDoneSvg from '../../assets/symbolDone.svg';

const styles = {
  message: {
    color: 'success.main',
    fontSize: (theme) => theme.typography.fontSize * 1.15,
    fontWeight: 'bold',
    mb: 2,
    mt: 1,
  },
  root: {
    '& .wrapperSvg': {
      '& svg': {
        fill: (theme) => theme.palette.success.main,
        height: '100%',
        width: '100%',
      },
      background: (theme) => lighten(theme.palette.success.main, 0.88),
      borderRadius: '100%',
      height: '144px',
      p: 4,
      width: '144px',
    },
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
};

const SuccessIconMessage = ({ children }) => (
  <Box sx={styles.root}>
    <ReactSVG className="wrapperSvg" src={iconDoneSvg} />
    <Typography sx={styles.message}>{children}</Typography>
  </Box>
);

SuccessIconMessage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default SuccessIconMessage;
